var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayPicture)?_c('img',{attrs:{"referrerpolicy":"no-referrer","src":_vm.displayPicture},on:{"error":_vm.imageError}}):_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v("person")])
}
var staticRenderFns = []

export { render, staticRenderFns }